<div class="offcanvas-header">
  <div class="d-flex justify-content-between align-items-center w-100 me-2 gap-3">
    <h4 class="offcanvas-title">Data Breakdown</h4>
    <div class="d-flex flex-grow-1 gap-3 align-items-center">
      <div>Filter:</div>
      <input
        type="text"
        class="form-control"
        placeholder="Filter products..."
        [(ngModel)]="filterTerm"
      />
      <button
        type="button"
        class="btn btn-outline-primary text-nowrap"
        (click)="resetSort()"
      >
        <i class="bi bi-arrow-counterclockwise"></i> Reset Sort
      </button>
      <button type="button" class="btn btn-outline-secondary text-nowrap" (click)="openColumnSelect()">
        <i class="bi bi-layout-three-columns"></i> Columns
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="toggleFullscreen()"
      >
        <i
          class="bi"
          [ngClass]="{
            'bi-fullscreen': !isFullscreen,
            'bi-fullscreen-exit': isFullscreen
          }"
        ></i>
      </button>
    </div>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="offcanvas-body d-flex flex-column">
  @if (products) {
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col" width="40px">#</th>
        <th *ngIf="isColumnVisible('enabled')" scope="col" width="80px">Enabled</th>
        <th *ngIf="isColumnVisible('productId')" scope="col">Product Id</th>
        <th *ngIf="isColumnVisible('barcode')" scope="col">Barcode</th>
        <th *ngIf="isColumnVisible('nationalId')" scope="col">National Id</th>
        <th *ngIf="isColumnVisible('brand')" scope="col" (click)="setSort('brand')" class="sortable">Brand</th>
        <th *ngIf="isColumnVisible('description')" scope="col">Description</th>
        <th *ngIf="isColumnVisible('uos')" scope="col" (click)="setSort('uos')" class="sortable">Uos</th>
        <th *ngIf="isColumnVisible('unit')" scope="col">Unit</th>
        <th *ngIf="isColumnVisible('facings')" scope="col">Facings</th>
        <th *ngIf="isColumnVisible('maxStack')" scope="col" (click)="setSort('maxStack')" class="sortable">Max Stack</th>
        <th *ngIf="isColumnVisible('casePack')" scope="col" (click)="setSort('casePack')" class="sortable">Case Pack</th>
        <th *ngIf="isColumnVisible('flow')" scope="col" (click)="setSort('flow')" class="sortable">Flow</th>
        <th *ngIf="isColumnVisible('shelfPosition')" scope="col">Shelf Position</th>
        <th *ngIf="isColumnVisible('orientation')" scope="col">Orientation</th>
        <th *ngIf="isColumnVisible('squeeze')" scope="col" (click)="setSort('squeeze')" class="sortable">Squeeze</th>
        <th *ngIf="isColumnVisible('dosfacing')" scope="col" (click)="setSort('dosPerFacing')" class="sortable">DOS/Facing</th>
        <th *ngIf="isColumnVisible('dos')" scope="col" (click)="setSort('dos')" class="sortable">DOS</th>
        <th *ngIf="isColumnVisible('cpi1')" scope="col" (click)="setSort('cpi1')" class="sortable">CPI 1</th>
        <th *ngIf="isColumnVisible('cpi2')" scope="col" (click)="setSort('cpi2')" class="sortable">CPI 2</th>
        <th *ngIf="isColumnVisible('category')" scope="col">Category</th>
        <th *ngIf="isColumnVisible('segment')" scope="col">Segment</th>
        <th *ngIf="isColumnVisible('family')" scope="col">Family</th>
        <th *ngIf="isColumnVisible('base')" scope="col">Base</th>
        <th *ngIf="isColumnVisible('status')" scope="col">Status</th>
        <th *ngIf="isColumnVisible('ranged')" scope="col">Ranged</th>
        <th *ngIf="isColumnVisible('willAdd')" scope="col">Will Add</th>
        <th *ngIf="isColumnVisible('willRemove')" scope="col">Will Remove</th>
        <th *ngIf="isColumnVisible('volume')" scope="col" (click)="setSort('volume')" class="sortable">Volume</th>
        <th *ngIf="isColumnVisible('sales')" scope="col" (click)="setSort('sales')" class="sortable">Sales</th>
        <th *ngIf="isColumnVisible('avgPrice')" scope="col" (click)="setSort('avgPrice')" class="sortable">Avg Price</th>
        <th *ngIf="isColumnVisible('brandavgrsp')" scope="col" (click)="setSort('brandAvgRSP')" class="sortable">Brand Avg RSP</th>
        <th *ngIf="isColumnVisible('brandmaxrsp')" scope="col" (click)="setSort('brandMaxRSP')" class="sortable">Brand Max RSP</th>
        <th *ngIf="isColumnVisible('dimensions')" scope="col">Dimensions</th>
        <th *ngIf="isColumnVisible('actions')" scope="col">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      @for (product of getFilteredProducts(); track product; let i = $index) {
      <tr
        [class]="isProductEnabled(product.productId) ? '' : 'table-secondary'"
        [class.table-primary]="
          product.productId === inspectedProduct
        "
      >
        <td scope="row" class="align-middle" width="40px">{{ i + 1 }}</td>
        <td *ngIf="isColumnVisible('enabled')" scope="row" class="align-middle text-center" width="80px">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="isProductEnabled(product.productId)"
            [disabled]="!canEdit()"
            (change)="toggleProductEnabled(product.productId, $event.target)"
          />
        </td>
        <td *ngIf="isColumnVisible('productId')" scope="row" class="align-middle">{{ product.productId }}</td>
        <td *ngIf="isColumnVisible('barcode')" scope="row" class="align-middle">{{ product.barcode }}</td>
        <td *ngIf="isColumnVisible('nationalId')" scope="row" class="align-middle">{{ product.nationalId }}</td>
        <td *ngIf="isColumnVisible('brand')" scope="row" class="align-middle">{{ product.brand }}</td>
        <td *ngIf="isColumnVisible('description')" scope="row" class="align-middle">{{ product.description }}</td>
        <td *ngIf="isColumnVisible('uos')" scope="row" class="align-middle">{{ product.uos }}</td>
        <td *ngIf="isColumnVisible('unit')" scope="row" class="align-middle">{{ product.unit }}</td>
        <td *ngIf="isColumnVisible('facings')" scope="row" class="align-middle">
          H: {{ product.horizontal }}<br />
          V:
          {{
            product.vertical_min === product.vertical_max
              ? product.vertical_min
              : product.vertical_min + "-" + product.vertical_max
          }}<br />
          D:
          {{ getDFacingsDisplay(product.productId) }}
        </td>
        <td *ngIf="isColumnVisible('maxStack')" scope="row" class="align-middle">{{ product.maxStack }}</td>
        <td *ngIf="isColumnVisible('casePack')" scope="row" class="align-middle">{{ product.casePack }}</td>
        <td *ngIf="isColumnVisible('flow')" scope="row" class="align-middle" [ngClass]="{ 'bg-danger text-light': product.categoryFlow == 0 }">
          {{ product.categoryFlow }}
        </td>
        <td *ngIf="isColumnVisible('shelfPosition')" scope="row" class="align-middle">
          {{ getShelfPosition(product.shelfPosition) }}
        </td>
        <td *ngIf="isColumnVisible('orientation')" scope="row" class="align-middle">
          {{ getOrientation(product.orientation) }}
        </td>
        <td *ngIf="isColumnVisible('squeeze')" scope="row" class="align-middle">
          W: {{ (product.squeezeW * 100).toFixed(0) }}%<br />
          H: {{ (product.squeezeH * 100).toFixed(0) }}%<br />
          D: {{ (product.squeezeD * 100).toFixed(0) }}%
        </td>
        <td *ngIf="isColumnVisible('dosfacing')" scope="row" class="align-middle" [ngClass]="{ 'bg-danger text-light': product.dimensions.depth === 0 || !Number.isFinite(getDosPerFacing(product)) }">
          {{ product.dimensions.depth !== 0 && Number.isFinite(getDosPerFacing(product)) ? getDosPerFacing(product).toFixed(2) : (product.dimensions.depth === 0 ? 'Depth Invalid' : 'No Sales') }}
        </td>
        <td *ngIf="isColumnVisible('dos')" scope="row" class="align-middle" [ngClass]="{ 'bg-danger text-light': !Number.isFinite(getLayoutDOS(product.productId)) }">
          {{ Number.isFinite(getLayoutDOS(product.productId)) ? getLayoutDOS(product.productId).toFixed(2) : 'No Sales' }}
        </td>
        <td *ngIf="isColumnVisible('cpi1')" scope="row" class="align-middle">{{ product.cpi1 }}</td>
        <td *ngIf="isColumnVisible('cpi2')" scope="row" class="align-middle">{{ product.cpi2 }}</td>
        <td *ngIf="isColumnVisible('category')" scope="row" class="align-middle">
          {{ product.categoryLevel1 }}
        </td>
        <td *ngIf="isColumnVisible('segment')" scope="row" class="align-middle">
          {{ product.categoryLevel2 }}
        </td>
        <td *ngIf="isColumnVisible('family')" scope="row" class="align-middle">
          {{ product.categoryLevel3 }}
        </td>
        <td *ngIf="isColumnVisible('base')" scope="row" class="align-middle">
          {{ product.categoryLevel4 }}
        </td>
        <td *ngIf="isColumnVisible('status')" scope="row" class="align-middle">
          {{ getStatusLabel(product.statusId) }}
        </td>
        <td *ngIf="isColumnVisible('ranged')" scope="row" class="align-middle text-center">
          @if (product.ranged === true) { <i class="bi bi-check-lg text-success"></i> }
          @else if (product.ranged === false) { <i class="bi bi-x-lg text-danger"></i> }
        </td>
        <td *ngIf="isColumnVisible('willAdd')" scope="row" class="align-middle text-center">
          @if (product.willAdd) { <i class="bi bi-check-lg text-success"></i> }
        </td>
        <td *ngIf="isColumnVisible('willRemove')" scope="row" class="align-middle text-center">
          @if (product.willRemove) { <i class="bi bi-check-lg text-danger"></i> }
        </td>
        <td *ngIf="isColumnVisible('volume')" scope="row" class="align-middle"
            [ngClass]="{ 'bg-danger text-light': product.salesData.salesQty === 0 }">
          {{ product.salesData.salesQty.toFixed(2) }}
        </td>
        <td *ngIf="isColumnVisible('sales')" scope="row" class="align-middle"
            [ngClass]="{ 'bg-danger text-light': product.salesData.sales === 0 }">
          {{ product.salesData.sales.toFixed(2) }}
        </td>
        <td *ngIf="isColumnVisible('avgPrice')" scope="row" class="align-middle">
          {{ product.salesData.averagePrice.toFixed(2) }}
        </td>
        <td *ngIf="isColumnVisible('brandavgrsp')" scope="row" class="align-middle">
          {{ product.brandAvgRSP.toFixed(2) }}
        </td>
        <td *ngIf="isColumnVisible('brandmaxrsp')" scope="row" class="align-middle">
          {{ product.brandMaxRSP.toFixed(2) }}
        </td>
        <td *ngIf="isColumnVisible('dimensions')" scope="row" class="align-middle"
            [ngClass]="{ 'bg-danger text-light': product.effectiveDimensions.width === 0 
                                               || product.effectiveDimensions.height === 0 
                                               || product.effectiveDimensions.depth === 0 }">
          W: {{ product.effectiveDimensions.width.toFixed(2) }}<br />
          H: {{ product.effectiveDimensions.height.toFixed(2) }}<br />
          D: {{ product.effectiveDimensions.depth.toFixed(2) }}
        </td>
        <td *ngIf="isColumnVisible('actions')" scope="row" class="align-middle">
          <div class="d-flex flex-column gap-1">
            <button
              class="btn btn-sm btn-primary"
              (click)="overrideProduct(product.productId)"
              *hasCapability="CapabilityType.GENERATE_PLANOGRAM"
            >
              Override
            </button>
            @if (getOverride(product.productId)) {
            <button
              (click)="clearProductOverride(product.productId)"
              class="btn btn-sm btn-danger" 
              *hasCapability="CapabilityType.GENERATE_PLANOGRAM"
            >
              Clear Override
            </button>
            }
            <button
              class="btn btn-sm btn-info"
              (click)="inspectProduct(product.productId)"
            >
              Inspect
            </button>
          </div>
        </td>
      </tr>
      }
    </tbody>
  </table>
  }
</div>
